import { request } from '@/utils/request'

/**
 * 上传用户文件（截屏等）
 * @param {File} file - 文件对象
 * @param {string|number} userId - 用户ID
 */
export function uploadUserFile (file, userId) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('userId', userId)
  return request('/zhima/userpc/uploadFile', {
    method: 'POST',
    body: formData
  })
}

/**
 * 用户登录
 * @param {{ account: string, pwd: string, role?: string, platform?: string }} params
 */
export function login (params) {
  return request('/zhima/user/login', {
    method: 'POST',
    body: {
      account: params.account,
      pwd: params.pwd,
      role: params.role != null ? String(params.role) : '0',
      platform: params.platform || 'pc'
    }
  })
}

/**
 * 获取用户信息及班级列表
 * @param {string} userId
 */
export function getUserInfo (userId) {
  return request('/zhima/user/getInfo', {
    method: 'GET',
    query: { userId }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js